import { lazy, Suspense, useEffect, Component } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ReactGA from 'react-ga4';
import { ThreeDots } from 'react-loader-spinner';

const ShopifyApplyURL = lazy(() => import("../modules/ShopifyApplyURL/component.shopifyApplyURL"));
const ShopifyApplication = lazy(() => import("../modules/ShopifyApplication/component.shopifyApplication"));
const Home = lazy(() => import("../modules/HomePage/component.Home"));
const ShopifyTest = lazy(() => import("../modules/ShopifyTest/component.shopifyTest"));

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div style={{ textAlign: "center", marginTop: "20%" }}>
          <p>Failed to load the page. Please check your connection and refresh.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);
  return null;
};

const CustomRoutes = () => {
  return (
    <BrowserRouter>
      <RouteTracker />
      <ChunkErrorBoundary>
        <Suspense fallback={<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)"}}><ThreeDots color="#5C068C" height="100" width="100" /></div>}>
          <Routes>
            <Route path="/" element={<ShopifyApplyURL />}></Route>
            <Route path="/apply-now" element={<ShopifyApplication />}></Route>
            <Route path="/home" element={<Home />}></Route>
            <Route path="/ShopifyTest" element={<ShopifyTest />}></Route>
          </Routes>
        </Suspense>
      </ChunkErrorBoundary>
    </BrowserRouter>
  );
};

export default CustomRoutes;
